import React, {useEffect, useState} from "react";

const Random = () => {
    const [random, setRandom] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setRandom(Math.floor(Math.random() * 10));
        }, 90);

        return () => clearInterval(interval);
    }, []);

    return <span className="runLoto">{random}</span>;
};

export default Random;
